import { render, staticRenderFns } from "./TheArticleToolbar.vue?vue&type=template&id=727224dc"
import script from "./TheArticleToolbar.vue?vue&type=script&lang=js"
export * from "./TheArticleToolbar.vue?vue&type=script&lang=js"
import style0 from "./TheArticleToolbar.vue?vue&type=style&index=0&id=727224dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports